// extracted by mini-css-extract-plugin
export default {"container":"style_container__MUJXl","trashed":"style_trashed__frxgW","archived":"style_archived__bTRqb"};